var _ellipse, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDocumentUpload = function SvgDocumentUpload(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 79,
    viewBox: "0 0 77 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 38.783,
    cy: 77,
    rx: 32,
    ry: 2,
    fill: "#ACC4EE",
    fillOpacity: 0.55
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M57.9444 29.1342L50.9125 30.2439C45.1458 31.1539 39.6204 26.6393 38.6019 20.1855L37.36 12.3156C37.1237 10.8179 35.8353 9.76523 34.4971 9.97641L24.1803 11.6044C16.6861 12.7871 11.4869 19.1894 13.021 28.9111L16.8284 53.0381C18.3625 62.7597 25.2806 67.2499 32.7748 66.0673L51.8998 63.0493C59.394 61.8667 64.5932 55.4643 63.0591 45.7427L60.8073 31.4734C60.571 29.9757 59.2827 28.9231 57.9444 29.1342Z",
    fill: "#448AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0789 9.20775C41.9051 8.24869 40.2979 9.28379 40.5428 10.836L42.0426 20.3397C42.67 24.3155 46.2071 27.1344 49.8812 26.5546C52.1971 26.2171 55.4089 25.7102 58.1584 25.2764C59.5453 25.0575 59.9873 23.1178 58.8422 22.1821C54.7153 18.7865 47.3161 12.6697 43.0789 9.20775Z",
    fill: "#448AFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 22.2327,
    y: 40.2225,
    width: 9.73195,
    height: 3.99861,
    rx: 1,
    transform: "rotate(-9.64774 22.2327 40.2225)",
    fill: "#91BAFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23.1714,
    y: 45.7415,
    width: 9.73195,
    height: 3.99861,
    rx: 1,
    transform: "rotate(-9.64774 23.1714 45.7415)",
    fill: "#91BAFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1094,
    y: 51.2603,
    width: 9.73195,
    height: 3.99861,
    rx: 1,
    transform: "rotate(-9.64774 24.1094 51.2603)",
    fill: "#91BAFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 33.571,
    y: 38.295,
    width: 9.73195,
    height: 3.99861,
    rx: 1,
    transform: "rotate(-9.64774 33.571 38.295)",
    fill: "#91BAFF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34.5095,
    y: 43.8138,
    width: 9.73195,
    height: 3.99861,
    rx: 1,
    transform: "rotate(-9.64774 34.5095 43.8138)",
    fill: "#91BAFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 35.448,
    y: 49.3328,
    width: 9.73195,
    height: 3.99861,
    rx: 1,
    transform: "rotate(-9.64774 35.448 49.3328)",
    fill: "#91BAFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 44.9099,
    y: 36.3676,
    width: 9.73195,
    height: 3.99861,
    rx: 1,
    transform: "rotate(-9.64774 44.9099 36.3676)",
    fill: "#91BAFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 45.8479,
    y: 41.8864,
    width: 9.73195,
    height: 3.99861,
    rx: 1,
    transform: "rotate(-9.64774 45.8479 41.8864)",
    fill: "#91BAFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7864,
    y: 47.4053,
    width: 9.73195,
    height: 3.99861,
    rx: 1,
    transform: "rotate(-9.64774 46.7864 47.4053)",
    fill: "#91BAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2591 49.772L61.2572 42.7702C61.2222 42.7352 61.1872 42.7352 61.1872 42.7002C60.9771 42.4901 60.6971 42.3151 60.417 42.175C60.382 42.175 60.382 42.175 60.347 42.175C60.0669 42.07 59.7868 42.035 59.5068 42C59.4017 42 59.3317 42 59.2267 42C59.0166 42 58.7716 42.07 58.5615 42.14C58.4565 42.175 58.3865 42.2101 58.3164 42.2451C58.0364 42.3851 57.7563 42.5251 57.5462 42.7702L50.5444 49.772C49.5291 50.7873 49.5291 52.4677 50.5444 53.483C51.5597 54.4983 53.2401 54.4983 54.2554 53.483L56.776 50.9624L56.776 65.6312C56.776 67.0666 57.9664 68.2569 59.4017 68.2569C60.8371 68.2569 62.0274 67.0666 62.0274 65.6312L62.0274 50.9624L64.5481 53.483C65.0732 54.0082 65.7384 54.2532 66.4036 54.2532C67.0687 54.2532 67.7339 54.0082 68.2591 53.483C69.2743 52.4677 69.2743 50.7873 68.2591 49.772Z",
    fill: "#448AFF"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDocumentUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "document-upload.273cdd8dd1591a043474392326b28796.svg";